import { render } from "./maintenance.vue?vue&type=template&id=5c34bf2c"
import script from "./maintenance.vue?vue&type=script&lang=js"
export * from "./maintenance.vue?vue&type=script&lang=js"

import "./maintenance.vue?vue&type=style&index=0&id=5c34bf2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__